module.exports = __webpack_public_path__ + "static/media/flag.6fd64dfa.svg";